import http from './http';

enum Api {
	GetBanners = '/admin/banners',
	GetBannerInfo = '/admin/bannerInfo',
	AddBanner = '/admin/BannerAdd',
	EditBanner = '/admin/BannerEdit',
	DeleteBanner = '/admin/BannerDelete',

	GetCategories = '/admin/categories',
	GetCategoryInfo = '/admin/categoryInfo',
	AddCategory = '/admin/categoryAdd',
	EditCategory = '/admin/categoryEdit',
	DeleteCategory = '/admin/categoryDelete',

	//market category list
	//GetMarketCategory = "/admin/marketCategory", //market product list와 중복됨
	AddMarketCategory = '/admin/marketCategoryAdd',
	EditMarketCategory = '/admin/marketCategoryEdit',
	DeleteMarketCategory = '/admin/marketCategoryDelete',

	//market product list
	CreateMarket = '/admin/marketCreate',
	GetMarket = '/admin/market',
	GetMarketOrder = '/admin/marketOrder',
	UpdateMarket = '/admin/marketUpdate',
	UpdateMarketOrder = '/admin/marketUpdateOrder',
	DeleteMarket = '/admin/marketDelete',
	DeleteMarketOrder = '/admin/marketOrderDelete',
	GetMarketCategory = '/admin/marketCategory',
	getUserCertification = '/admin/userCertificationList',

	//wmuContentsList
	GetSession = '/admin/session',
	getSelectContent = '/admin/content',
	GetContents = '/admin/contents',
	CreateContents = '/admin/contentAdd',
	EditContents = '/admin/contentEdit',
	DeleteContents = '/admin/deleteContent',

	//referral
	GetReferral = '/admin/referral',
	GetInfoReferral = '/admin/infoReferral',

	//withdrawal
	GetWithdrawal = '/admin/withdrawal',
	DeleteWithdrawal = '/admin/deleteWithdrawal',

	//challengeContents
	GetChallengeContents = '/admin/challengeContents',
	DeleteChallengeContents = '/admin/deleteChallengeContents',

	//challengeSession
	CreateChallengeSession = '/admin/challengeSessionAdd',
	GetChallengeSession = '/admin/challengeSession',
	EditChallengeSession = '/admin/challengeSessionEdit',
	DeleteChallengeSession = '/admin/deleteChallengeSession',

	//notionTerms
	CreateNotionTerms = '/admin/notionTermsAdd',
	GetNotionTerms = '/admin/notionTerms',
	EditNotionTerms = '/admin/notionTermsEdit',
	DeleteNotionTerms = '/admin/deleteNotionTerms',

	//notionNotice
	CreateNotionNotice = '/admin/notionNoticeAdd',
	GetNotionNotice = '/admin/notionNotice',
	EditNotionNotice = '/admin/notionNoticeEdit',
	DeleteNotionNotice = '/admin/deleteNotionNotice',

	//notification
	CreateNotification = '/admin/pushNotification',
	GetNotification = '/admin/pushNotifications',
	DeleteNotification = '/admin/pushNotification',
}

/**
 * @description: get banners data info api
 */

export async function getBannersApi(params: any) {
	return await http.post(Api.GetBanners, params);
}

/**
 * @description: get banner data info api
 */

export async function getBannerInfoApi(params: any) {
	return await http.post(Api.GetBannerInfo, params);
}

/**
 * @description: add banner api
 */

export async function addBannerApi(params: any) {
	return await http.post(Api.AddBanner, params);
}

/**
 * @description: edit banner api
 */

export async function editBannerApi(params: any) {
	return await http.post(Api.EditBanner, params);
}

export async function deleteBannerApi(idx: any) {
	return await http.delete(`${Api.DeleteBanner}/${idx}`);
}

/**
 * @description: get categories data info api
 */

export async function getCategoriesApi(params: any) {
	return await http.post(Api.GetCategories, params);
}
/**
 * @description: get category data info api
 */

export async function getCategoryInfoApi(params: any) {
	return await http.post(Api.GetCategoryInfo, params);
}

/**
 * @description: add category api
 */

export async function addCategoryApi(params: any) {
	return await http.post(Api.AddCategory, params);
}

/**
 * @description: edit category api
 */

export async function editCategoryApi(params: any) {
	return await http.post(Api.EditCategory, params);
}

export async function deleteCategoryApi(idx: any) {
	return await http.delete(`${Api.DeleteCategory}/${idx}`);
}

/**
 * @description: get category data info api
 */

export async function getMarketCategoryInfoApi(params: any) {
	return await http.post(Api.GetCategoryInfo, params);
}

/**
 * @description: get market product List
 */

export async function GetMarketCategoryApi() {
	return await http.post(Api.GetMarketCategory);
}

export async function createMarketApi(params: any) {
	return await http.post(Api.CreateMarket, params);
}

export async function getMarketApi(params: any) {
	return await http.post(Api.GetMarket, params);
}

export async function getMarketOrderApi(params: any) {
	return await http.post(Api.GetMarketOrder, params);
}
//카테고리 추가
export async function getMarketCategoryApi(params: any) {
	return await http.post(Api.GetMarketCategory, params);
}

export async function updateMarketApi(params: any) {
	const updateMarketValue = params.get('updateMarket');
	const updateMarketNumber = Number(updateMarketValue);
	const url = `${Api.UpdateMarket}/${updateMarketNumber}`;
	return await http.put(url, params);
}

export async function updateMarketUpdateApi(params: any) {
	return await http.put(Api.UpdateMarketOrder, params);
}

export async function deleteMarketApi(params: any) {
	const url = `${Api.DeleteMarket}/${params}`;
	return await http.delete(url);
}

export async function deleteMarketOrderApi(idx: any) {
	return await http.delete(`${Api.DeleteMarketOrder}/${idx}`);
}

/**
 * @description: get UserCertification List
 */

export async function getUserCertification(params: any) {
	return await http.post(Api.getUserCertification, params);
}

/**
 * @description: get wmuContents List CRUD
 */

//getSession
export async function getSessionApi() {
	return await http.get(Api.GetSession);
}

//getSelectContent
export async function getSelectContentApi(param: any) {
	return await http.get(`${Api.getSelectContent}/${param}`);
}

//getWMUcontents
export async function getContentsApi(params: any) {
	return await http.post(`${Api.GetContents}/${params.session_id}`, params);
}

//createWMU
export async function createContents(params: any) {
	return await http.post(Api.CreateContents, params);
}

//editWMU
export async function editContents(params: any) {
	return await http.post(Api.EditContents, params);
}

//deleteWMU
export async function deleteContents(deleteIdx: any) {
	const url = `${Api.DeleteContents}/${deleteIdx}`;
	return await http.delete(url);
}

//////////////////////

/**
 * @description: get market category List
 */

/**
 * @description: add market category api
 */

export async function addMarketCategoryApi(params: any) {
	return await http.post(Api.AddMarketCategory, params);
}

/**
 * @description: edit market category api
 */

export async function editMarketCategoryApi(params: any) {
	const editMarketCategoryValue = params.get('updateMarketCategory');
	const editMarketCategoryValueNumber = Number(editMarketCategoryValue);
	const url = `${Api.EditMarketCategory}/${editMarketCategoryValueNumber}`;
	return await http.post(url, params);
	// return await http.post(Api.EditMarketCategory, params);
}

/**
 * @description: delete market category api
 */

export async function deleteMarketCategoryApi(params: any) {
	const url = `${Api.DeleteMarketCategory}/${params}`;
	return await http.delete(url);
}

//referral
export async function getUserReferralApi(payload: any) {
	return await http.post(Api.GetReferral, payload);
}

//infoRferral
export async function getInfoReferralApi(payload: any) {
	return await http.post(Api.GetInfoReferral, payload);
}

export async function getWithdrawalApi(payload: any) {
	return await http.post(Api.GetWithdrawal, payload);
}

export function deleteWithdrawalApi(idx: any) {
	return http.delete(`${Api.DeleteWithdrawal}/${idx}`);
}

//challengeContents
export function getChallengeContents(payload: any) {
	return http.post(Api.GetChallengeContents, payload);
}

export function deleteChallengeContents(idx: any) {
	return http.delete(`${Api.DeleteChallengeContents}/${idx}`);
}
//challengeSession
export function addChallengeSessionApi(payload: any) {
	return http.post(Api.CreateChallengeSession, payload);
}

export function getChallengeSessionApi(payload: any) {
	return http.post(Api.GetChallengeSession, payload);
}

export function editChallengeSessionApi(payload: any) {
	return http.post(Api.EditChallengeSession, payload);
}

export function deleteChallengeSessionApi(payload: any) {
	return http.delete(`${Api.DeleteChallengeSession}/${payload}`);
}

//notionTerms
export function addNotionTermsApi(payload: any) {
	return http.post(Api.CreateNotionTerms, payload);
}

export function getNotionTermsApi(payload: any) {
	return http.post(Api.GetNotionTerms, payload);
}

export function editNotionTermsApi(payload: any) {
	return http.post(Api.EditNotionTerms, payload);
}
export function deleteNotionTermsApi(payload: any) {
	return http.delete(`${Api.DeleteNotionTerms}/${payload}`);
}

//notionNotice
export function addNotionNoticeApi(payload: any) {
	return http.post(Api.CreateNotionNotice, payload);
}

export function getNotionNoticeApi(payload: any) {
	return http.post(Api.GetNotionNotice, payload);
}

export function editNotionNoticeApi(payload: any) {
	return http.post(Api.EditNotionNotice, payload);
}
export function deleteNotionNoticeApi(payload: any) {
	return http.delete(`${Api.DeleteNotionNotice}/${payload}`);
}

//notification
export function addNotificationApi(payload: any) {
	return http.post(Api.CreateNotification, payload);
}

export function getNotificationApi(payload: any) {
	return http.post(Api.GetNotification, payload);
}

export function deleteNotificationApi(payload: any) {
	return http.delete(`${Api.DeleteNotification}/${payload}`);
}

// stepup module
export function getBuildingNameListApi(payload: any) {
	return http.post('/admin/buildingNameList', payload);
}
